import React, { useEffect, useState } from 'react';
import { Button } from 'antd';
import { fetchChatImage } from '@/apis/chat';

const ChatImage = ({ attachment }) => {
  const [url, setUrl] = useState(''); const [failed, setFailed] = useState(false); const [retry, setRetry] = useState(0);
  useEffect(() => {
    let active = true; let objectUrl;
    setFailed(false); setUrl('');
    fetchChatImage(attachment.content_url).then(blob => {
      if (!active) return;
      objectUrl = URL.createObjectURL(blob); setUrl(objectUrl);
    }).catch(() => { if (active) setFailed(true); });
    return () => { active = false; if (objectUrl) URL.revokeObjectURL(objectUrl); };
  }, [attachment.content_url, retry]);
  if (failed) return <Button size="small" onClick={() => setRetry(n => n + 1)}>图片加载失败，重试</Button>;
  return url ? <a href={url} target="_blank" rel="noreferrer"><img src={url} alt="聊天图片" loading="lazy" /></a> : <span>图片加载中…</span>;
};
export default ChatImage;
